import { render } from "./event_list.vue?vue&type=template&id=3977d62e&scoped=true"
import script from "./event_list.vue?vue&type=script&lang=js"
export * from "./event_list.vue?vue&type=script&lang=js"

import "./event_list.vue?vue&type=style&index=0&id=3977d62e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3977d62e"]])

export default __exports__